export enum LoginType {
    EMAIL = 'email',
    NOSTR = 'nostr'
}